<!-- The main container helps detect outside clicks -->
@if (contactDetails(); as contactDetails) {
  <div #popupContainer class="contact-popup-container">
    <!-- The button that triggers the popup -->
    <button class="trigger-button" (click)="togglePopup()">
      <!-- Contact Icon -->
      <span class="icon-contact-us" data-cy="navigationMenuContactUsIcon"></span>
      <span>{{ contact }}</span>
      <!-- Dropdown Arrow Icon -->
      <div
        class="icon-dropdown"
        style="mask-image: url(./assets/images/ui/header-icon-down.svg)"
        data-cy="dropiconImage"
      ></div>
    </button>

    <!-- The popup, shown conditionally with *ngIf -->
    @if (showPopup()) {
      <div class="popup">
        <div class="popup-content">
          <!-- Popup Header -->
          <div class="popup-header">
            <span aria-label="ContactUs" tabindex="0" class="popup-title">{{ contact }}</span>
            <button class="close-button" (click)="closePopup()">
              <!-- Close 'X' Icon -->
              <span class="close icon-exit" aria-label="Close"></span>
            </button>
          </div>
          <!-- Popup Body -->
          @for (section of contactDetails.contactUs; track section.label) {
            <div class="divider"></div>
            <div class="popup-body">
              @if (section.label) {
                <p tabindex="0" class="section-label">{{ section.label }}</p>
              }

              <div class="phone-info">
                <!-- Phone Icon -->
                <span class="icon-call" data-cy="iconCall"></span>
                <a href="tel:{{ section.phoneNumbers.customerCareNumber }}">
                  <span>{{ section.phoneNumbers.customerCareNumber }}</span>
                </a>
              </div>
              <div class="hours-info">
                @if (section.hoursOfOperation.customerCareHours_Weekday) {
                  <p
                    tabindex="0"
                    aria-label="{{ section.hoursOfOperation.customerCareHours_Weekday }}"
                  >
                    {{ section.hoursOfOperation.customerCareHours_Weekday }}
                  </p>
                }
                @if (section.hoursOfOperation.customerCareHours_Weekend) {
                  <p
                    tabindex="0"
                    aria-label="{{ section.hoursOfOperation.customerCareHours_Weekend }}"
                  >
                    {{ section.hoursOfOperation.customerCareHours_Weekend }}
                  </p>
                }
              </div>
            </div>
          }
          @if (contactDetails.claimsMessage) {
            <div class="divider"></div>
            <div class="popup-body">
              <p tabindex="0" class="claims-message" data-cy="contactUsClaimsMessage">
                {{ contactDetails.claimsMessage }}
              </p>
            </div>
          }
        </div>
      </div>
    }
  </div>
}
